import React from 'react';
import {LauncherComponentBase} from '../../../base-components/launcher-component-base';
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import MenuItem from '@material-ui/core/MenuItem';

export interface AppBarButtonComponentProps {
    onClick: () => void;
    text: string;
}

export class AppBarButtonComponent extends LauncherComponentBase<AppBarButtonComponentProps> {

    private _renderMobileButton() {
        return (
            <MenuItem onClick={this.props.onClick}>
                <IconButton onClick={this.props.onClick}>
                    {this.props.children}
                </IconButton>
                {this.props.text}
            </MenuItem>
        )
    }

    private _renderPCButton() {
        return (
            <Tooltip title={this.props.text}>
                <IconButton color="inherit" onClick={this.props.onClick}>
                    {this.props.children}
                </IconButton>
            </Tooltip>
        );
    }

    render() {
        if(this.services.deviceTypeDetection.isMobile) {
            return this._renderMobileButton();
        } else {
            return this._renderPCButton();
        }
    }
}